import { IViewPortionContext } from './viewPortionContext';

export enum ViewPortionActionTypes {
	SET_DATA = 'SET_DATA',
	SET_PORTION_MODIFIER_GROUP_ID = 'SET_PORTION_MODIFIER_GROUP_ID',
	SET_PORTION_MODIFIER_GROUP_MODIFIERS = 'SET_PORTION_MODIFIER_GROUP_MODIFIERS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
}

interface ISetData {
	type: ViewPortionActionTypes.SET_DATA;
	payload: {
		portionFullInfo: IViewPortionContext['portionFullInfo'];
	};
}

interface ISetPortionModifierGroupId {
	type: ViewPortionActionTypes.SET_PORTION_MODIFIER_GROUP_ID;
	payload: {
		portionModifierGroupId: IViewPortionContext['portionModifierGroupId'];
		portionModifierGroupModifiers: IViewPortionContext['portionModifierGroupModifiers'];
	};
}

interface ISetPortionModifierGroupModifiers {
	type: ViewPortionActionTypes.SET_PORTION_MODIFIER_GROUP_MODIFIERS;
	payload: {
		portionModifierGroupModifiers: IViewPortionContext['portionModifierGroupModifiers'];
	};
}

interface ISetTranslationTab {
	type: ViewPortionActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewPortionContext['selectedTranslationTab'];
	};
}

export type TViewPortionAction =
	| ISetData
	| ISetPortionModifierGroupId
	| ISetPortionModifierGroupModifiers
	| ISetTranslationTab;
